import React, { useEffect, useState } from 'react'
import { BrowserRouter as Router } from 'react-router-dom'
import LoadingScreen from './components/loadingScreen/LoadingScreen'
import HomePage from './containers/Home/HomePage'

function App() {
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 3000)
    return () => clearTimeout(timer)
  }, [])

  return <Router>{loading ? <LoadingScreen /> : <HomePage />}</Router>
}

export default App